import React from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import { loadedMainScript, servedMainScript } from '../utils/appVersion';

const POLL_MS = 5 * 60 * 1000;

/**
 * "A new version of FlowGate is ready" with a Reload button, once the served build differs from
 * the one this tab loaded. Checked when the tab becomes visible again and every five minutes.
 * Reloading is safe because the assistant keeps its unsaved work in local storage and the
 * manual builder auto-saves; the guard on unsaved edits still asks first where it applies.
 */
const NewVersionBanner = ({ pollMs = POLL_MS }) => {
  const [stale, setStale] = React.useState(false);

  React.useEffect(() => {
    const loaded = loadedMainScript();
    if (!loaded) return undefined; // a dev server or a test: nothing to compare against
    let cancelled = false;
    const check = async () => {
      const served = await servedMainScript();
      if (!cancelled && served && served !== loaded) setStale(true);
    };
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    const timer = setInterval(check, pollMs);
    document.addEventListener('visibilitychange', onVisible);
    check();
    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [pollMs]);

  if (!stale) return null;
  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} data-testid="new-version-banner">
      <Alert
        severity="info"
        variant="filled"
        action={<Button color="inherit" size="small" onClick={() => window.location.reload()}>Reload</Button>}
      >
        A new version of FlowGate is ready. Your unsaved work is kept.
      </Alert>
    </Snackbar>
  );
};

export default NewVersionBanner;
